import React, { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import SupportPage from './pages/SupportPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import CategoryListingPage from './pages/CategoryListingPage';
import CategoryDetailPage from './pages/CategoryDetailPage';
import ProductDetailPage from './pages/ProductDetailPage';
import SearchResultsPage from './pages/SearchResultsPage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import OrderConfirmationPage from './pages/OrderConfirmationPage';
import OrderHistoryPage from './pages/OrderHistoryPage';
import OrderDetailPage from './pages/OrderDetailPage';
import CancelOrderChatPage from './pages/CancelOrderChatPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import EmailVerificationPage from './pages/EmailVerificationPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ProfilePage from './pages/ProfilePage';
import FavouritesPage from './pages/FavouritesPage';
import ProtectedRoute from './components/ProtectedRoute';
import MobileBottomNav from './components/MobileBottomNav';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { FavouritesProvider } from './context/FavouritesContext';
import { ToastProvider } from './context/ToastContext';

// Moving between routes should start at the top of the new page. Links that
// carry a #hash are left alone, because HomePage scrolls those to their section.
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0 });
  }, [pathname, hash]);

  return null;
};

function App() {
  return (
    <AuthProvider>
      <CartProvider>
      <FavouritesProvider>
      <ToastProvider>
        <div className="App pb-16 md:pb-0">
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />

            {/* Public catalog (DE-14178): browsing, searching and viewing a
                product must never require an account. Authentication starts
                at checkout and on customer-specific pages below. */}
            <Route path="/categories" element={<CategoryListingPage />} />
            <Route path="/categories/:categoryKey" element={<CategoryDetailPage />} />
            <Route path="/products/:idOrSku" element={<ProductDetailPage />} />
            <Route path="/search" element={<SearchResultsPage />} />
            <Route path="/cart" element={<CartPage />} />

            <Route path="/checkout" element={<ProtectedRoute><CheckoutPage /></ProtectedRoute>} />
            <Route path="/order-confirmation/:saleId" element={<ProtectedRoute><OrderConfirmationPage /></ProtectedRoute>} />
            <Route path="/orders" element={<ProtectedRoute><OrderHistoryPage /></ProtectedRoute>} />
            <Route path="/orders/:id" element={<ProtectedRoute><OrderDetailPage /></ProtectedRoute>} />
            <Route path="/orders/:id/cancel" element={<ProtectedRoute><CancelOrderChatPage /></ProtectedRoute>} />
            <Route path="/account" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
            <Route path="/favourites" element={<ProtectedRoute><FavouritesPage /></ProtectedRoute>} />

            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/verify-email" element={<EmailVerificationPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />

            {/* Unknown in-app paths fall back to the homepage rather than a blank screen. */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <MobileBottomNav />
        </div>
      </ToastProvider>
      </FavouritesProvider>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
